// src/services/settings.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const publicAwardsApi = createApi({
  reducerPath: "public-awards",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/public-awards/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["ScholarshipEnums"],
  endpoints: (builder) => ({
    getPublicAwards: builder.query({
      query: (params) => {
        const queryString = new URLSearchParams(params).toString();
        return `?${queryString}`;
      },
    }),
    getScholarshipEnums: builder.query({
      query: () => "/scholarship-enums",
      providesTags: ["ScholarshipEnums"],
    }),
    // Public documents for a scholarship
    getPublicScholarshipDocuments: builder.query({
      query: (scholarshipId) => `/scholarships/${scholarshipId}/documents`,
    }),
  }),
});

export const {
  useGetPublicAwardsQuery,
  useGetScholarshipEnumsQuery,
  useGetPublicScholarshipDocumentsQuery,
} = publicAwardsApi;
export default publicAwardsApi;
export { publicAwardsApi };
